"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = require('js-cookie');
var models_1 = require("./common/models");
var constants_1 = require("./common/constants");
var url_param_1 = require("./common/url-param");
var encrypt_1 = require("./common/encrypt");
var data_from_url_1 = require("./data-from-url");
var HubConfig = /** @class */ (function () {
    function HubConfig() {
        this.origins = [];
    }
    return HubConfig;
}());
var Hub = /** @class */ (function () {
    function Hub(config) {
        if (config === void 0) { config = new HubConfig; }
        this.config = config;
        var requestData = data_from_url_1.getDataFromUrl();
        if (requestData) {
            //console.log(requestData)
            //debugger
            // * verifica o JWT e o sso_domains
            if (requestData.payload.value) {
                var domainsSSO = JSON.parse(atob(requestData.payload.value.split('.')[1])).sso_domains.length ? (JSON.parse(atob(requestData.payload.value.split('.')[1]))).sso_domains.map(function (item) { return item = 'https://' + item; }) : [requestData.origin];
                this.config.origins = domainsSSO;
                //this.config.origins.push("http://localhost:8085")
            }
            else {
                this.config.origins = [requestData.origin];
            }
        }
        this.validateConfig();
        this.register();
    }
    Hub.prototype.register = function () {
        var requestData = data_from_url_1.getDataFromUrl();
        if (!requestData || !this.isAllowedOrigin(requestData.origin)) {
            return;
        }
        // if(requestData.payload.value) {
        //     console.log(requestData)
        //     debugger
        // }
        this.redirect(requestData);
    };
    Hub.prototype.redirect = function (requestData) {
        var responseValue = this.resolveAction(requestData);
        var response = new models_1.Response({
            action: requestData.action,
            payload: responseValue,
            disableNewRedirect: requestData.disableNewRedirect,
            needToLogin: requestData.needToLogin
        });
        var _a = requestData.returnTo.split('?'), url = _a[0], queryString = _a[1];
        // Preserva os query params da url de retorno
        var queryParams = url_param_1.urlParamsToObj(queryString);
        queryParams.cdc = encrypt_1.encode(response);
        window.location.href = url + "?" + url_param_1.objToUrlParams(queryParams);
    };
    Hub.prototype.resolveAction = function (request) {
        var action = request.action, payload = request.payload;
        if (action === constants_1.ACTIONS.SET) {
            Cookies.set(payload.key, payload.value);
            return;
        }
        if (action === constants_1.ACTIONS.GET) {
            return Cookies.get(payload.key);
        }
        if (action === constants_1.ACTIONS.DELETE) {
            Cookies.remove(payload.key);
            return;
        }
        throw new models_1.InvalidActionError();
    };
    Hub.prototype.isAllowedOrigin = function (origin) {
        return this.config.origins.some(function (item) { return item === origin; });
    };
    Hub.prototype.validateConfig = function () {
        //console.log(this.config)
        if (!this.config.origins) {
            throw new models_1.InvalidConfigError('Property "origins" is required');
        }
    };
    return Hub;
}());
exports.Hub = Hub;
